import './ui/flashquiz.css';

import { useContext, useEffect, useRef, useState } from 'react';

import { Host, Input } from '../App';
import { on, once, transitionEnd } from '../ui/helpers';
import { Button, IconBut } from '../ui/buttons';
import { ToggleOverlay } from './contexts';
import { DevMode } from '../contexts';


// name = "create-set"
export function CreateSet({ show }) {
    const [set, setSet] = useState([]);
    const parentRef = useRef(null), itemsRef = useRef(null);

    const closeOverlay = useContext(ToggleOverlay).close;

    useEffect(() => {
        let t_id = show && parentRef.current.classList.remove("close");

        return () => {
            clearTimeout(t_id);
        }
    }, [show])


    return (
        show &&
        <div className='interface close' ref={parentRef}>
            <div className="content max" style={{ overflow: "hidden auto" }}>
                <div className='heading fw pad'>
                    <div className='flex fw mid-align' style={{ gap: "10px" }}>
                        <IconBut className="fa-solid fa-xmark" onClick={close}>
                            <span className='sr-only'>Close</span>
                        </IconBut>

                        <div className='flex mid-align' style={{ justifyContent: "space-between", flexGrow: 1 }}>
                            <div> Create Set </div>
                            <Button className="flex mid-align br-1" style={{ padding: "5px", gap: "10px" }} onClick={submit}>
                                <i className="fa-solid fa-tick"></i>
                                Save
                            </Button>
                        </div>
                    </div>
                </div>
                <div style={{ padding: "10px" }}>
                    <div className="fw">
                        <label className='fw flex-col'>
                            <span className='label'> Title </span>
                            <textarea placeholder='Subject, chapter, unit ...'></textarea>
                        </label>
                        <hr></hr>
                        {
                            set.map((data, i) => <CardSlot key={i} index={i} a={data?.a} q={data?.q} />)
                        }

                    </div>
                </div>
                <div className='abs'>
                    <IconBut className="fa-solid fa-plus" onClick={addSlot}>
                        <span className='sr-only'>Add</span>
                    </IconBut>
                </div>
            </div>
        </div>
    )

    function CardSlot({ index, q, a }) {
        const qRef = useRef(null), ansRef = useRef(null);

        useEffect(() => {
            const map = getMap();

            const slot = { qElem: qRef, aElem: ansRef };
            map.set(index, slot);

            return () => map.delete(index);
        }, [index])

        useEffect(() => {
            const qElem = qRef.current, ansElem = ansRef.current;
            qElem.value = q ?? '';
            ansElem.value = a ?? '';
        }, [q, a])


        return (
            <div className='flex-col fw '>
                <Input label="Term" required ref={qRef} placeholder="term ..." spacing="mb-1" />
                <Input label="Definition" required ref={ansRef} placeholder="definition ..." />
            </div>
        )
    }


    function getMap() {
        let el = itemsRef.current;
        if (!el) {
            el = itemsRef.current = new Map();
        }
        return el;
    }

    function addSlot() {
        const data = savedData();
        const clonedSet = [...data, {}];
        setSet(clonedSet);
    }

    function savedData() {
        const map = getMap(), list = [];

        for (let { qElem, aElem } of map.values()) {
            list.push({
                q: qElem.current.value ?? '',
                a: aElem.current.value ?? ''
            })
        }
        console.log(list);
        return list
    }

    function close() {
        once(transitionEnd, () => {
            // setDisplay(false);
            closeOverlay("create-set");
            setSet([]);
        });
        parentRef.current.classList.add("close");
    }

    function submit() {
        const list = savedData();

        fetch(`${Host}flashquiz/create`,
            {
                method: "post",
                fd: JSON.stringify(list)
            }
        ).then(res => res.json())
            .then(console.log)
    }
}


// name = "flashdeck"
export function FlashDeck({ show }) {
    const [QandA, setQandA] = useState(DevMode ? devDeck : []);
    const [index, setIndex] = useState(0);
    const closeOverlay = useContext(ToggleOverlay).close;

    const mainRef = useRef(null);


    const currentCard = QandA.length && QandA[index];

    useEffect(() => {
        const t_id = show && setTimeout(() => mainRef.current.classList.remove("close"), 50);

        return () => {
            t_id && clearTimeout(t_id);
        }
    }, [show])

    useEffect(() => {
        let ignore = true;

        fetch(`${Host}flash`)
            .then(res => res.json())
            .then(res => {
                !ignore && setQandA(res);
            })
            .catch(err => {
                // show error
                !ignore && console.error(err);
            })

        return () => {
            ignore = true;
        }

    }, []);

    return (
        show &&
        <div className='interface close' ref={mainRef}>
            <div className="content max flex-col">
                <div className='flex fw mid-align' style={{ padding: "10px", justifyContent: "left" }}>
                    <IconBut className="fa-solid fa-xmark fa-lg" onClick={close}>
                        <span className='sr-only'>
                            Close
                        </span>
                    </IconBut>
                </div>
                <div className="grow" style={{ position: "relative" }}>
                    <div className='flex-col gap-10 abs-mid'>
                        <div className="abs-mid">
                            {
                                currentCard &&
                                <FlashCard answer={currentCard.answer} question={currentCard.question} />
                            }
                        </div>
                        <div className="abs flex mid-align even-space">
                            <Button>
                                No
                            </Button>
                            <Button>
                                Not Sure
                            </Button>
                            <Button>
                                Yes
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    function close() {
        const el = mainRef.current;
        once(transitionEnd, el, () => closeOverlay('flashdeck'));
        el.classList.add("close");
    }
}


function FlashCard({ answer, question }) {
    const mainRef = useRef(null);
    const [flipped, setFlipped] = useState(false);

    return (
        <div className="flip-cont" style={{ width: "350px", height: "500px" }} onClick={flip} onTouchStart={handleTouchStart} ref={mainRef} >
            <div className={`inner br-1 ${flipped ? "flip" : ''}`}>
                <div className="front">
                    {question}
                </div>
                <div className="back">
                    {answer}
                </div>
            </div>
        </div>
    )


    function handleTouchStart(e) {
        const { touches: { 0: { clientX } }, target: { clientWidth } } = e, startX = clientX;
        mainRef.current.classList.add("no-trans");

        on('touchmove', handleTouchMove);
        once('touchend', handleTouchEnd);

        function handleTouchMove(e) {
            const { touches: { 0: { clientX } } } = e, posX = clientX;

            const diffX = posX - startX, absDiff = Math.abs(diffX);
            let ratio = diffX / clientWidth;

            if (ratio > 1) {
                ratio = 1;
            } else if (ratio < -1) {
                ratio = -1
            }
            // max +- 15 degrees 
            const angle = ratio * 15;

            mainRef.current.style.transform = `translateX(${diffX}px) rotate(${angle}deg)`;
        }

        function handleTouchEnd(e) {
            mainRef.current.classList.remove("no-trans");
            const { changedTouches: { clientX }, currentTarget } = e, endX = clientX, threshold = clientWidth / 2;

            currentTarget.removeEventListener('touchmove', handleTouchMove);

            const diffX = endX - startX, absDiff = Math.abs(diffX);
            // do sumn abut final state
            // if threshold passed, switch to next card
            if (absDiff > threshold) {

            } else {
                // else reset card position
                mainRef.current.style.transform = '';
            }

            console.log("done");
        }
    }

    function flip() {
        setFlipped(!flipped);
    }
}


export function Quiz() {
    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState({});
    const [index, setIndex] = useState();
    const inpRef = useRef(null), currentQ = index && questions?.[index];


    useEffect(() => {
        let ignore = false;

        fetch(`${Host}quiz`).then(res => res.json())
            .then(res => {
                !ignore && setQuestions(res.Questions);
            })
            .catch(err => {
                !ignore && console.error(err);
                // show error
            })

        return () => {
            ignore = true;
        }
    }, [])

    return (
        <></>
        // <div className='quiz'>
        //     <div className='content'>
        //         <form method="post" onSubmit={handleAnswer}>
        //             <div className="form-body">
        //                 <div className='flex-col'>
        //                     {/* Q and A */}
        //                     <div>
        //                         {currentQ?.text}
        //                     </div>
        //                     <input ref={inpRef} />
        //                     <Button type="submit">
        //                         Save Answer
        //                     </Button>
        //                 </div>
        //                 <Button onClick={end}>
        //                     Submit
        //                 </Button>
        //             </div>
        //         </form>
        //         <div className='flex pagn'>
        //             {
        //                 questions.map( (q, index) => {
        //                     return (
        //                         <button key={q.id} onClick={() => goTo(index)}> {index} </button>
        //                     )
        //                 })
        //             }
        //         </div>
        //     </div>
        // </div>
    )


    function goTo(selector) {
        setIndex(selector);
    }

    function handleAnswer(e) {
        const { target } = e
        e.preventDefault();

        const { current: { value } } = inpRef;

        if (!currentQ || !value) return

        const ansClone = { ...answers, [currentQ]: value }
        setAnswers(ansClone);

    }

    function end() {
        // verify action
        const fd = JSON.stringify(answers);

        fetch(`${Host}quiz`, {
            method: "post",
            body: fd
        }).then(res => res.json())
            .then(res => {
            })
            .catch(err => {
                console.error(err)
                // show error
            })
    }
}



const devDeck = [
    {
        question: "What is life?",
        answer: "Aristotle is still philosophizing about that"
    },
    {
        question: "What is life?",
        answer: "Aristotle is still philosophizing about that"
    },
    {
        question: "What is life?",
        answer: "Aristotle is still philosophizing about that"
    },
]